<template>
	<transition name="fade">
		<div class="library library-all">
			<div class="ss-breadcrumb">
				<div class="container-hts">
					<ul class="margin-0 p-0">
						<li><router-link to="/thu-vien">Thư viện</router-link></li>
						<li>
							<router-link :to="{name: 'library', query: {lop: classId, tab: tabPagelink}}">
								{{ paramSearchLessons.className ? paramSearchLessons.className : bookInfo.className }}
							</router-link>
						</li>
						<li v-if="bookInfo.practiceTypeName && bookInfo.practiceTypeId">
							<router-link :to="{name: 'library', query: {lop: classId, tab: tabPagelink}}">
								{{ bookInfo.practiceTypeName }}
							</router-link>
						</li>
						<li v-if="typeLoading">
              <router-link v-if="typeLoading === typePageLink" :to="{name: 'library', query: {lop: classId, tab: tabPagelink}}">
								Học liệu điện tử
							</router-link>
              <router-link v-else-if="typeLoading === typeLesson" :to="{name: 'library', query: {lop: classId, tab: tabLesson}}">
								Bài giảng điện tử
							</router-link>
              <router-link v-else :to="{name: 'library', query: {lop: classId, tab: typeActiveLearning}}">
								Chương trình học chủ động
							</router-link>
							<!-- <router-link :to="{name: 'library', query: {lop: classId, tab: typeLoading === typePageLink ? tabPagelink : tabLesson}}">
								{{ typeLoading === typePageLink ? 'Học liệu điện tử' : 'Bài giảng điện tử'}}
							</router-link> -->
						</li>
						<li><span>{{ nameTypeLibCurr }}</span></li>
					</ul>
				</div>
			</div>
			<div class="ss-data">
				<div class="container-hts">
					<div class="library__wrap display-flex justify-content-between">
						<!-- <SidebarAll :bookInfo="bookInfo" /> -->
						<div class="library__data">
							<!-- <FilterForm class="library__search" /> -->
              <FilterMobileListAll
                v-if="isMobile"
                :tabActive="tabActive"
                :types="[{id: tabByTypeLib, name: `Tất cả ${nameTypeLibCurr}`}, {id: tabByFilterBox, name: `${nameTypeLibCurr} theo mục lục sách giáo khoa`}]"
                @searchTab="filterLibByTab"
              />
              <div v-else class="library__data__head display-flex-center justify-content-between">
                <b-tabs>
                  <b-tab :title="`Tất cả ${nameTypeLibCurr}`" :active="tabActive === tabByTypeLib" @click="filterLibByTab(tabByTypeLib)"></b-tab>
                  <b-tab :title="`${nameTypeLibCurr} theo mục lục sách giáo khoa`" :active="tabActive === tabByFilterBox" @click="filterLibByTab(tabByFilterBox)"></b-tab>
                </b-tabs>
                <div class="library__data__head__collapse">
                  <a
                    @click="toggleCollapseKeyword"
                    href="javascript:;"
                    class="btn-collapse btn border-rd-20 font-size-15 primary-color"
                    :class="{'btn-main': openCollapseFilterKey, 'btn-main-light': !openCollapseFilterKey }"
                  >
                    <i class="icon-search margin-0" :class="{'color-light': openCollapseFilterKey, 'primary-color': !openCollapseFilterKey }"></i>
                  </a>
                  <a
                    href="javascript:;"
                    @click="toggleCollapseGroup"
                    class="btn-collapse btn border-rd-20 font-size-15"
                    :class="{'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }"
                  >
                    Bộ lọc <i class="icon-arrow-down font-size-12" :class="{'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
                  </a>
                </div>
              </div>
              <!-- <div class="library__data__filter display-flex-center justify-content-between">
                <div class="library__data__filter__keyword">
                  <div class="input-custom-icon">
                    <input type="text" name="keyword" class="color_bg_gray_light border-0 border-rd-20" v-model.lazy="keyword" v-debounce="300" />
                    <i class="icon-search primary-color"></i>
                  </div>
                </div>
                <div class="library__data__filter__sort">
                  <select name="sort" class="border-0 secondary-color-txt">
                    <option value="name">Sắp xếp theo tên</option>
                  </select>
                </div>
              </div> -->
              <!-- <div class="library__data__head display-flex-center justify-content-between">
                <h1 class="primary-color-txt font-size-24 font-sanpro-semibold">{{ nameTypeLibCurr }}</h1>
                <a v-b-toggle.collapse_filter class="btn-collapse btn btn-main-light border-rd-20 font-size-15 primary-color">Bộ lọc <i class="icon-arrow-down font-size-12"></i></a>
              </div> -->
              <b-collapse id="collapse_filter_keyword" class="mt-2" :visible="openCollapseFilterKey">
                <div class="library__data__filter display-flex-center justify-content-between">
                  <div class="library__data__filter__keyword">
                    <div class="input-custom-icon">
                      <input type="text" name="keyword" class="color_bg_gray_light border-0 border-rd-20" placeholder="Tìm kiếm" v-model.lazy="keyword" v-debounce="300" />
                      <i class="icon-search primary-color"></i>
                    </div>
                  </div>
                  <div class="library__data__filter__sort">
                    <!-- <a href="javascript:;" class="secondary-color-txt" @click="handleFilterSort">Sắp xếp theo tên <i class="secondary-color-txt font-size-14" :class="{'icon-arrow-up': paramSearchLessons.direction === 'desc', 'icon-arrow-down': paramSearchLessons.direction === 'asc'}"></i></a> -->
                    <!-- <div>
                      <b-dropdown id="dropdown-1" text="Sắp xếp theo tên" class="m-md-2 btn-dropdown">
                        <b-dropdown-item>Sắp xếp theo mới nhất</b-dropdown-item>
                        <b-dropdown-item>Sắp xếp theo xem nhiều nhất</b-dropdown-item>
                      </b-dropdown>
                    </div> -->
                    <div class="position-rel">
                    <!-- <b-dropdown right id="dropdown-1" text="Sắp xếp học liệu" class="m-md-2 btn-dropdown">
                      <template title="Sắp xếp học liệu">
                       
                      </template>
                      <b-dropdown-item href="javascript:;" @click="sorteEarliest">Mới nhất</b-dropdown-item>
                      <b-dropdown-item href="javascript:;" @click="sortMostView">Xem nhiều nhất</b-dropdown-item>
                    </b-dropdown> -->
                    <select name="" id="" class="custom-select css-select" @change="sortLibrary($event)">
                      <option :value="0">Tất cả</option>
                      <option :value="1">Mới nhất</option>
                      <option :value="2">Xem nhiều nhất</option>
                    </select>
                    <i
                      class="icon-arrow-down primary-color font-size-12"
                      style="position: absolute; top: 9px; right: 12px;"
                    ></i>
                    </div>
                    <!-- <select name="sort" class="border-0 secondary-color-txt">
                      <option value="name">Sắp xếp theo tên</option>
                    </select> -->
                  </div>
                </div>
              </b-collapse>
              <b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
                <FilterCollapse />
              </b-collapse>

							<div class="library__list" v-if="tabActive === tabByTypeLib">
								<div class="row">
									<template v-for="(item, index) of librariesData">
										<ItemLibrary v-if="item && tabPagelink" :dataSource="item" :isLesson="tabPagelink" :class="`col-12 col-sm-4 col-lg-3`" :isPlay="true" :position="index" />
										<ItemLibrary v-else-if="item && tabLesson" :dataSource="item" :isLesson="tabLesson" :class="`col-12 col-sm-4 col-lg-3`" :isPlay="true" :position="index" />
										<ItemLibrary v-else-if="item && tabActiveLearning" :dataSource="item" :isLesson="tabActiveLearning" :class="`col-12 col-sm-4 col-lg-3`" :isPlay="true" :position="index" />
									</template>
								</div>
								<p v-if="!librariesData || librariesData.length === 0" class="margin-0 font-size-20 secondary-color-txt text-center">Dữ liệu đang cập nhật!</p>
                <div id="library_end"></div>
							</div>
							<div class="library__book" v-else-if="tabActive === tabByFilterBox">
								<ResultBookFilter v-if="paramSearchLessons.filterType === tabPagelink" :typeLoading="tabPagelink" :dataSource="resultBookPageLinkFilter" />
								<ResultBookFilter v-if="paramSearchLessons.filterType === tabLesson" :typeLoading="tabLesson" :dataSource="resultBookLessonFilter" />
								<ResultBookFilter v-if="paramSearchLessons.filterType === tabActiveLearning" :typeLoading="tabActiveLearning" :dataSource="resultBookActiveLearning" />

								<p v-if="(paramSearchLessons.filterType === tabPagelink && resultBookPageLinkFilter.length === 0) || (paramSearchLessons.filterType === tabLesson && resultBookLessonFilter.length === 0)" class="margin-0 font-size-20 secondary-color-txt text-center">Dữ liệu đang cập nhật!</p>
                <div id="library_end"></div>
							</div>
							<!-- <div class="library__paging">
								<Pagination v-if="pagingData.totalPage > 1 && tabActive === tabByTypeLib" :totalPage="pagingData.totalPage" :page="paramSearchLessons.pageIndex" @eventPagination="changePage" />
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import { STORE_KEY, TYPE_PAGE_LINK_LOAD, TYPE_LESSON_LOAD, TAB_MEDIA_PAGE_LINK, TAB_LESSON, TAB_ACTIVE_LEARNING, TYPE_ACTIVE_LEARN_LOAD } from './../_store/constants'
	import { getLessonsPlan, getMediaListInLibs, getListActiveLearningAll } from './../_api/'
	import { getInfoBookBasic } from '@/modules/exercises/_api'
  import debounce from '@/directives/debounce';

	export default {
		name: 'LibraryAll',
		components: {
			SidebarAll: () => import('./../_components/list/SidebarAll.vue'),
			ItemLibrary: () => import('./../_components/list/ItemLibrary.vue'),
			FilterForm: () => import('./../_components/list/FilterForm.vue'),
      FilterCollapse: () => import('./../_components/list/FilterCollapse.vue'),
      ResultBookFilter: () => import('./../_components/list/ResultBookFilter.vue'),
      FilterMobileListAll: () => import('./../_components/list/FilterMobileListAll.vue'),
      Pagination: () => import('@/components/Pagination.vue')
		},
    directives: { debounce },
		data () {
			return {
				librariesData: [],
        bookInfo: {},
        typeLesson: TYPE_LESSON_LOAD,
        typePageLink: TYPE_PAGE_LINK_LOAD,
        typeActiveLearning: TYPE_ACTIVE_LEARN_LOAD,
				nameTypeLibCurr: '',
        tabPagelink: TAB_MEDIA_PAGE_LINK,
        tabLesson: TAB_LESSON,
        tabActiveLearning: TAB_ACTIVE_LEARNING,
        tabByTypeLib: 1,
        tabByFilterBox: 2,
        tabActive: 1,
        keyword: '',
        openCollapseFilterGroup: false,
        openCollapseFilterKey: true,
        pagingData: {},
        pagingBookData: {},
        elmEndItem: null,
        observer: null,
        windowWidth: 0
			}
		},
		computed: {
			...mapState(STORE_KEY, ['paramSearchLessons', 'bookIdActiveSuccess', 'resultBookPageLinkFilter', 'resultBookLessonFilter', 'paramFilterBook', 'paramFilterBookLesson', 'resultBookActiveLearning', 'paramActiveLearning']),
			...mapState('auth', ['loginPopupData']),

			libAllId() {
				return this.$route.params.id;
			},
			typeLoading() {
				return this.$route.params.type;
			},
      classId() {
        return this.$route.params.classId;
      },
      isMobile () {
        return this.windowWidth < 991 ? true : false;
      }
		},
		watch: {
			'paramSearchLessons': 'getLibsData',
      keyword: "handleFilterKeyword",
      // 'paramFilterBook': 'getBooksByType',
      // 'paramFilterBookLesson': 'getBooksByType',
      // keyword(newVal) {
      //   return debounceFunc(this.handleFilterKeyword(newVal), 40000)
      // },
			// bookIdActiveSuccess(newVal) {
			// 	if(newVal && newVal === this.bookId) {
			// 		this.fetchBookInfo();
			// 	}
			// },
			loginPopupData(newVal) {
  			newVal && Object.keys(newVal).length && this.fetchBookInfo();
  		}
		},
		created() {
			this.initParamsSearch();
		},
		mounted() {
      this.elmEndItem = document.getElementById('library_end')
      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth);
        //Init
        this.getWindowWidth()
      })

      if (this.elmEndItem) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
      }
      
      this.setParamSearchLesson({...this.paramSearchLessons, sort: 'DisplayArea,CountView', pageIndex: 1})

		},
    beforeDestroy () {
      this.setParamSearchLesson({...this.paramSearchLessons, filterType: TAB_MEDIA_PAGE_LINK,classId: 0, subjectId: 0, pageLinkGroupId: 0, bookLessonPlanTypeId: 0, pageIndex: 1})
      this.acSetParamFilterBook({...this.paramFilterBook, classId: 0, subjectId: 0, bookGroupId: 0, pageLinkGroupId: 0, scrollData: false, pageIndex: 1 })
      this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId: 0, subjectId: 0, bookGroupId: 0, bookLessonPlanTypeId: 0, scrollData: false, pageIndex: 1 })
      this.observer.unobserve(this.elmEndItem);
    },
		methods: {
			...mapActions('common', ['setLoading']),
			...mapActions(STORE_KEY, ['setParamSearchLesson', 'acSetParamFilterBook', 'acGetBookOfPageLinks', 'acGetBookOfLessons', 'acSetParamFilterBookLesson', 'acSetParamActiveLearning', 'acGetBookActiveLearning']),
      ...mapMutations(STORE_KEY, ['SET_BOOK_PAGE_LINK_FILTER_RESULT', 'SET_BOOK_LESSON_FILTER_RESULT', 'SET_PARAMS_ACTIVE_LEARNING', 'SET_BOOK_ACTIVE_LEARNING']),

			initParamsSearch() {
				// this.setLoading(true)
				this.fetchBookInfo();
        if(this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK) {
					this.setParamSearchLesson({...this.paramSearchLessons, documentTypeId: parseInt(this.libAllId)});
          const { subjectId, classId, bookGroupId } = this.paramSearchLessons
          this.acSetParamFilterBook({...this.paramFilterBook, classId, subjectId, bookGroupId, pageLinkGroupId: parseInt(this.libAllId), scrollData: true })
				} else if(this.paramSearchLessons.filterType === TYPE_LESSON_LOAD){
					this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: parseInt(this.libAllId)});
          const { subjectId, classId, bookGroupId } = this.paramSearchLessons
          this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, classId, subjectId, bookGroupId, bookLessonPlanTypeId: parseInt(this.libAllId), scrollData: true })
				} else if(this.paramSearchLessons.filterType === TYPE_ACTIVE_LEARN_LOAD){
					this.setParamSearchLesson({...this.paramSearchLessons, bookLessonPlanTypeId: parseInt(this.libAllId)});
          const { subjectId, classId, bookGroupId } = this.paramSearchLessons
          this.acSetParamActiveLearning({...this.paramFilterBookLesson, classId, subjectId, bookGroupId, bookLessonPlanTypeId: parseInt(this.libAllId), scrollData: true })
				}
			},

      getWindowWidth (event) {
        this.windowWidth = window.innerWidth
      },

			fetchBookInfo() {
				let self = this;
				self.bookId && getInfoBookBasic(self.bookId).then(res => {
					if(res && res.data && !res.errors) {
						self.bookInfo = res.data;
					}
				})
			},

			getLibsData() {
				let self = this;
				if(self.typeLoading === TYPE_PAGE_LINK_LOAD) {
					getMediaListInLibs(self.paramSearchLessons).then(res => {
						if(res && res.data && res.data.list && !res.errors) {
              let dataTypeactive = res.data.list.filter(lib => lib.documentTypeId === parseInt(self.libAllId))[0];
              self.nameTypeLibCurr = dataTypeactive.name;
              self.librariesData = self.paramSearchLessons.pageIndex === 1 ? dataTypeactive.listBookPageLinks : [...self.librariesData, ...dataTypeactive.listBookPageLinks];
              self.pagingData = dataTypeactive.paging;
						}
					}).finally(() => self.setLoading(false));
				} else if(self.typeLoading === TYPE_LESSON_LOAD){
					getLessonsPlan(self.paramSearchLessons).then(res => {
						if(res && res.data && res.data.list && !res.errors) {
							let dataTypeactive = res.data.list.filter(lib => lib.bookLessonPlanTypeId === parseInt(self.libAllId))[0];
              self.nameTypeLibCurr = dataTypeactive.name;
							self.librariesData = self.paramSearchLessons.pageIndex === 1 ? dataTypeactive.listBookLessonPlans : [...self.librariesData, ...dataTypeactive.listBookLessonPlans];
              self.pagingData = dataTypeactive.paging;
              // console.log('self.librariesData', self.librariesData);
              
						}
					}).finally(() => self.setLoading(false));
				} else {
					getListActiveLearningAll(self.paramSearchLessons).then(res => {
						if(res && res.data && res.data.list && !res.errors) {
							// let dataTypeactive = res.data.list.filter(lib => lib.bookLessonPlanTypeId === parseInt(self.libAllId))[0];
              self.nameTypeLibCurr = 'Video';
              self.librariesData = self.paramSearchLessons.pageIndex === 1 ? res.data.list : [...self.librariesData, ...res.data.list];

              // self.librariesData = self.paramSearchLessons.pageIndex === 1 ? dataTypeactive.listBookLessonPlans : [...self.librariesData, ...dataTypeactive.listBookLessonPlans];
              
              // self.librariesData = res.data.list;
              // console.log('self.librariesData', self.librariesData);
              self.pagingData = res.data.paging;

              
              
              // self.pagingData = res.data.paging;
              // console.log('hahaha vao day tiep di nao', res);
							// let dataTypeactive = res.data.list.filter(lib => lib.bookLessonPlanTypeId === parseInt(self.libAllId))[0];
              // self.nameTypeLibCurr = dataTypeactive.name;
              // console.log('dataTypeactive.name 123', dataTypeactive.name);
							// self.librariesData = self.paramSearchLessons.pageIndex === 1 ? dataTypeactive.listBookLessonPlans : [...self.librariesData, ...dataTypeactive.listBookLessonPlans];
              // self.pagingData = dataTypeactive.paging;
						}
					}).finally(() => self.setLoading(false));
				}
			},

      getBooksByType () {
        if(this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK) {
          this.acGetBookOfPageLinks(this.paramFilterBook).then(res => {
            let resultList = this.paramFilterBook.pageIndex === 1 ? res.list : [...this.resultBookPageLinkFilter, ...res.list]
            this.SET_BOOK_PAGE_LINK_FILTER_RESULT(resultList)
            if (res.paging) {
              this.pagingBookData = res.paging
            }
          })
        } else if(this.paramSearchLessons.filterType === TAB_LESSON){
          this.acGetBookOfLessons(this.paramFilterBookLesson).then(res => {
            let resultList = this.paramFilterBookLesson.pageIndex === 1 ? res.list : [...this.resultBookLessonFilter, ...res.list]
            this.SET_BOOK_LESSON_FILTER_RESULT(resultList)
            if (res.paging) {
              this.pagingBookData = res.paging
            }
          })
        } else if(this.paramSearchLessons.filterType === TAB_ACTIVE_LEARNING){
          this.acGetBookActiveLearning(this.paramActiveLearning).then(res => {
            let resultList = res.list
            this.SET_BOOK_ACTIVE_LEARNING(resultList)
            if (res.paging) {
              this.pagingBookData = res.paging
            }
          })
        }
      },

      sortDataByTitle (data, type = 'desc') {
        return data.sort(function (a, b) {
          let nameA = a.title.toUpperCase()
          let nameB = b.title.toUpperCase()
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      },

      filterLibByTab (tab) {
        this.tabActive = tab
        if (tab === this.tabByFilterBox) {
          this.getBooksByType()
        }
      },

      handleFilterKeyword () {
        this.setParamSearchLesson({...this.paramSearchLessons, keyword: this.keyword});
        this.setParamsForFilterBook({ keyword: this.keyword })
      },

      setParamsForFilterBook (params) {
        if(this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK) {
          this.acSetParamFilterBook({...this.paramFilterBook, ...params })
        } else if(this.paramSearchLessons.filterType === TAB_LESSON) {
          this.acSetParamFilterBookLesson({...this.paramFilterBookLesson, ...params})
        } else {
          this.acSetParamActiveLearning({...this.paramFilterBookLesson, ...params})
        }
      },

      toggleCollapseGroup () {
        this.openCollapseFilterGroup = !this.openCollapseFilterGroup
      },

      toggleCollapseKeyword () {
        this.openCollapseFilterKey = !this.openCollapseFilterKey
      },

      handleFilterSort () {
        this.setParamSearchLesson({...this.paramSearchLessons, sort: 'Title', direction: this.paramSearchLessons.direction === 'desc' ? 'asc' : 'desc', pageIndex: 1})
      },
      // // Mới nhất
      // sorteEarliest () {
      //   this.setParamSearchLesson({...this.paramSearchLessons, sort: "PagelinksId" , direction: "desc", pageIndex: 1})
      // },
      // // Nhiều view nhất
      // sortMostView () {
      //   this.setParamSearchLesson({...this.paramSearchLessons, sort: "CountView" , direction: "desc", pageIndex: 1})
      // },
      sortLibrary (event) {
        // console.log(event.target.value);
        if(event.target.value == 0) {
          this.setParamSearchLesson({...this.paramSearchLessons, sort: "DisplayArea,CountView" , direction: "", pageIndex: 1})
        }
        if(event.target.value == 1) {
          this.setParamSearchLesson({...this.paramSearchLessons, sort: "PagelinksId" , direction: "desc", pageIndex: 1})
        }
        if(event.target.value == 2) {
          this.setParamSearchLesson({...this.paramSearchLessons, sort: "CountView" , direction: "desc", pageIndex: 1})
        }
      },

      handleScrollEnd () {
        if (this.tabActive === this.tabByFilterBox && ((this.pagingBookData && this.pagingBookData.totalPage && this.pagingBookData.pageIndex < this.pagingBookData.totalPage) || Object.keys(this.pagingBookData).length === 0)) {
          let paramPaging = {pageIndex: this.paramSearchLessons.filterType === TAB_MEDIA_PAGE_LINK ? this.paramFilterBook.pageIndex + 1 : this.paramFilterBookLesson.pageIndex + 1}
          this.setParamsForFilterBook(paramPaging)
          this.getBooksByType()
        } else if ( this.pagingData && this.pagingData.totalPage && this.paramSearchLessons.pageIndex < this.pagingData.totalPage) {
          this.setParamSearchLesson({...this.paramSearchLessons, pageIndex: this.paramSearchLessons.pageIndex + 1})
        } else {
          // this.setParamSearchLesson({...this.paramSearchLessons, pageIndex: this.paramSearchLessons.pageIndex + 1})
        }
      },
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../../../assets/scss/mixins";
  @import "./../../../assets/scss/variables";
  @import "./../../../assets/scss/general";

  .css-select{
    height:30px; 
    line-height:18px;
    padding: 0 30px 0 15px !important;
  }
  .custom-select {
    border: none !important;
    border-radius: 20px !important;
    height: 30px;
    background: #f3f6fb !important;
    font-size: 15px !important;
    height: 30px !important;
    padding-top: 0;
    padding-bottom: 0;
  }
  
	.collapse-subject{
		.subject-list{
			padding-left: 18px;
			margin-top: 6px;
		}
	}

	.library {
		&__search {
			margin-bottom: 35px;
		}

    &__book {
      padding-top: 20px;
    }

		&__sidebar {
			width: 27%;
			margin-right: 5%;
			padding-top: 8px;

			ul {
				li {
					min-height: 36px;
					padding: 5px 18px;
					@extend .border-rd-8;
					margin-bottom: 2px;
					@extend .list-style-none;
					@extend .display-flex-center;

					.subject-cl{
						@extend .primary-color-txt;
					}

					a {
						@extend .secondary-color-txt;
						@extend .font-size-16;
					}

					&.active, &:hover {
						background: $btn_hover_color;

						>a {
							@extend .primary-color;
							@extend .font-sanpro-semibold;
						}
					}
				}
			}
			.form-active{
				margin-top: 20px;
			}
		}

		&__data {
			width: 100%;

      &__head {
        border-bottom: 1px solid $color_border_main;

        &__collapse {
          >* {
            &:not(:last-child) {
              margin-right: 15px;
            }
          }
        }

        .btn-collapse {
          line-height: 1.3;
          // color: $primary_color;
          letter-spacing: 0.03em;

          i {

            &:not(.margin-0) {
              margin-left: 6px;
            }
          }
        }
      }

      &__filter {
        padding: 20px 0 10px;

        &__keyword {
          width: 28%;
          
          input {
            padding: 5px 30px 5px 15px!important;
            @extend .full-width;
          }

          i {
            color: $primary_color;
          }
        }
      }
		}

    &__list {
      padding-top: 20px;
    }

		&__tabs {
			&__content {
				padding: 35px 0 20px;
			}
		}

		@media screen and ( max-width: 991px ) {
			&__wrap {
				display: block;
			}

			&__sidebar, &__data {
				width: 100%;
			}
			&__sidebar {
				margin-bottom: 30px;
			}
		}

    @media screen and ( max-width: 600px ) {
			&__data {
				&__head {
					display: block;

					&__collapse {
						padding: 8px 0;
					}
				}

				&__filter {
          padding-top: 0;

					&__keyword {
						width: 100%;
            margin-right: 10px;
					}
				}

        #collapse_filter_keyword {
          margin-top: 0!important;
        }
			}
		}
	}
  #collapse_filter {
    border-bottom: 1px solid $color_border_main;
  }
</style>